export const variants = ['primary', 'secondary', 'tertiary', 'none'] as const;
export const sizes = ['small', 'large'] as const;
export const targets = ['_blank', '_self', '_parent', '_top'] as const;
